import { z } from 'zod';
/**
 * The villages' portals (ADR 0017). The client names a portal and nothing
 * else: the server knows where the player stands, which portals they have
 * used, their gold, and moves them.
 */
const PortalIdSchema = z.string().min(1).max(32);
/** Use the portal one stands at: it is remembered, and its window opens. */
export const UsePortalMessageSchema = z.object({ portalId: PortalIdSchema });
/** Travel, from anywhere, to a portal used before. */
export const TeleportMessageSchema = z.object({ portalId: PortalIdSchema });
/** Get back up here after a fall; asked at the portal itself. */
export const SetRespawnMessageSchema = z.object({ portalId: PortalIdSchema });
/** To the owner alone, on joining and after every change: what they may travel to. */
export const TravelStateSchema = z.object({
    discovered: z.array(PortalIdSchema),
    /** The portal they get back up at, or null for the zone's shrine. */
    respawn: PortalIdSchema.nullable(),
});
/** To the traveller, once moved; the new inventory, gold included, follows. */
export const TeleportedSchema = z.object({
    portalId: PortalIdSchema,
    cost: z.number().int().min(0),
});
export const TRAVEL_REFUSALS = [
    'invalid',
    'unknown-portal',
    'undiscovered',
    'here',
    'missing-gold',
    'too-far',
    'dead',
    'in-combat',
];
export const TravelRejectedSchema = z.object({
    reason: z.enum(TRAVEL_REFUSALS),
    /** For `in-combat`: whole seconds left before a journey is allowed. */
    seconds: z.number().int().min(1).optional(),
});
//# sourceMappingURL=travel.js.map